import styled from "styled-components";
import { narrowScreenMediaQuery } from "../constants/styles";

// Form panel — max-width 480 keeps the form readable on ultra-wide monitors
// even though the split grid column can be much wider. Centered horizontally
// inside its grid cell.
const AuthPanel = styled.div`
  width: 100%;
  max-width: 480px;
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media ${narrowScreenMediaQuery} {
    max-width: 100%;
  }
`;

export default AuthPanel;
